var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"app-main",style:({
    height: _vm.$route.meta.appMainMinHeight || 'calc(100vh - 106px)',
  })},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('keep-alive',{attrs:{"include":_vm.cachedViews}},[(!_vm.$route.meta.link)?_c('router-view',{key:_vm.key}):_vm._e()],1)],1),_c('iframe-toggle')],1)}
var staticRenderFns = []

export { render, staticRenderFns }